import useAsyncData from "../../../hooks/use-async-data";
import orderService from "../order.service";
import OrderJoin from "./order-join";
import OrderJoinParams from "./order-join-params";

const useOrderJoin = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<OrderJoin | null>(null);

  const load = async (params: OrderJoinParams, signal: AbortSignal) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const orderJoin = await orderService.joinOrder(params, signal);

      setData(orderJoin);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useOrderJoin;
